var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiliation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.45,13.64l1.94-2.18A4.39,4.39,0,0,1,28,17.29l-3.74,4.2a4.39,4.39,0,0,1-6.87-.39",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.55,25.36l-1.94,2.18a4.39,4.39,0,0,1-6.56-5.83l3.74-4.2a4.39,4.39,0,0,1,6.87.39",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliation);
export default __webpack_public_path__ + "static/media/affiliation.a60c8b4aedd30f89508a2ef5a1678b1e.svg";
export { ForwardRef as ReactComponent };